import copyObject from "./_copyObject.js";
import getSymbolsIn from "./_getSymbolsIn.js";
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}
export default copySymbolsIn;
